import { type Authorizer } from '@owner/auth'

/**
 * Launch surface RBAC gate, mirroring Hestia's launch tab
 * (apps/hestia/src/contexts/Authorization/routeRequirements.ts). All five
 * permissions must pass for the launch onboarding surface to be reachable —
 * shared by the launch route `authZ` and any UI (e.g. the home setup banner)
 * that navigates into it, so nav visibility and route access stay in sync.
 *
 * @param user - The authorizer for the current session.
 */
export const canAccessLaunch = (user: Authorizer): boolean =>
  user.can('read', 'funnel') &&
  user.can('update', 'funnel') &&
  user.can('edit', 'menu') &&
  user.can('update', 'brand') &&
  user.can('create', 'customer')
